import api from './api';

export const listDechargeArgents = (params = {}) => api.get('/decharge-argents', { params });
export const getDechargeArgent = (id) => api.get(`/decharge-argents/${id}`);
export const createDechargeArgent = (data) => api.post('/decharge-argents', data);
export const validateDechargeArgent = (id) => api.post('/decharge-argents/validate', { id });
export const refuseDechargeArgent = (id, refuseReason) => api.post('/decharge-argents/refuse', { id, refuseReason });
export const remisDecharge = (id, remisValue) => api.post('/decharge-argents/remis', { id, remisValue });

export default { listDechargeArgents, getDechargeArgent, createDechargeArgent, validateDechargeArgent, refuseDechargeArgent, remisDecharge };
